import script from "./GerenciarDestaques.vue?vue&type=script&setup=true&lang=js"
export * from "./GerenciarDestaques.vue?vue&type=script&setup=true&lang=js"

import "./GerenciarDestaques.vue?vue&type=style&index=0&id=010bda96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010bda96"]])

export default __exports__